// Gedeelten Texter: Navigatiounsleescht, Foussleescht, Sproochewiel.
// Iwwersetzung vu fr/common.js — genee déiselwecht Schlësselen.
// D’Schlësselen packs.* gehéieren AUSSCHLIISSLECH an dëse Fragment (tp/tpList
// liesen se, mat Réckgrëff op de Wäert aus der Datebank).
export default {
  'nav.home': 'Startsäit',
  'nav.shop': 'Shop',
  'nav.rules': 'Spillregelen',
  'nav.about': 'Iwwer eis',
  'nav.contact': 'Kontakt',
  'nav.cart': 'Mäi Wuerekuerf',
  'nav.admin': 'Administratioun',
  'nav.adminShort': 'Admin',
  'nav.adminTitle': 'Admin-Zougang',
  'nav.order': 'Bestellen',
  'nav.cartEmpty': 'Äre Wuerekuerf ass eidel',
  'nav.checkout': 'Bezuelen',
  'nav.login': 'Aloggen',
  'nav.loginShort': 'Login',
  'nav.logout': 'Ausloggen',
  'nav.orders': 'Bestellungen',
  'nav.myOrders': 'Meng Bestellungen',
  'nav.profile': 'Profil',
  'nav.myProfile': 'Mäi Profil',
  'nav.language': 'Sprooch',

  'footer.tagline':
    'Loosst eis zesummen a Famill magesch Momenter kreéieren! Eis Puzzlen maachen aus der Uskënnegung vum Geschlecht vum Bëbee en onvergiesslecht Abenteuer.',
  'footer.badge.interactive': '🎲 Interaktiv',
  'footer.badge.festive': '🎊 Festlech',
  'footer.badge.family': '💝 Famill',
  'footer.nav': 'Navigatioun',
  'footer.legal': 'Rechtleches',
  'footer.privacy': 'Dateschutz',
  'footer.terms': 'Allgemeng Verkafsbedingungen',
  'footer.paymentSecurity': 'Sécher bezuelen',
  'footer.legalNotice': 'Impressum',
  'footer.connected': 'Bleif um Lafenden',
  'footer.newsletter': 'Kréi déi lescht Infoen:',
  'footer.newsletterPlaceholder': 'däin@email.com',
  'footer.madeWith': 'Gemaach mat',
  'footer.madeFor': 'fir magesch Famillen.',

  // Produkttexter (kommen normalerweis aus der Datebank, hei iwwersat via tp/tpList).
  'packs.flash.name': 'Pack Essentiel',
  'packs.flash.description': 'Nëmmen d’Spillschachtel — de Rescht bereet Dir selwer vir.',
  'packs.flash.longDescription':
    'Dir kritt d’Joyful-Reveal-Schachtel, a soss näischt: eelef Puzzlestécker, déi Fro fir Fro gewonne ginn, an dat zwieleft zum Rubbelen — dat, wat alles verréit. D’Regele sinn hannen op der Schachtel zesummegefaasst an och online ze fannen. D’Froen schreift Dir selwer, an Dir suergt selwer fir eppes, fir déi zwou Equipen z’ënnerscheeden. Wann Dir léiwer hätt, datt alles scho prett ass, da kuckt Iech de Pack Premium un.',
  'packs.flash.features':
    'D’Spillschachtel mat hiren 12 Stécker|11 Stécker ze gewannen + 1 Rubbelstéck|D’Regelen zesummegefaasst hannen op der Schachtel|Online-Versioun vun de Regelen iwwer de QR-Code',

  'packs.premium.name': 'Pack Premium',
  'packs.premium.description': 'Dat komplett Spill: alles ass prett, Dir musst näischt méi virbereeden.',
  'packs.premium.longDescription':
    'Alles, wat an der Schachtel ass, plus déi dräi Accessoiren, déi den Owend ausmaachen: zwee Stoffsäckelcher, fir d’Equipen ze bilden, de Froebou gedréckt op Kartong vu 400 g mat den eelef Froen, déi scho geschriwwe sinn, an eng eidel Virlag, fir Är eege Froen z’erfannen, an eng Souvenir-Enveloppe, déi Dir no der Feier hannen an e Kader stiecht.',
  'packs.premium.features':
    'D’Spillschachtel mat hiren 12 Stécker|2 Stoffsäckelcher fir déi zwou Equipen|De Froebou gedréckt op Kartong vu 400 g|Eng eidel Virlag fir Är eege Froen|D’Souvenir-Enveloppe fir no der Feier opzehiewen',
  "footer.maFacture": "Meng Rechnung erëmfannen",
};
